/**
 * Карточка cookies: записывает согласие в cookie и скрывает уведомление.
 */
class CookiesCard {

    /**
     * Находит карточку и скрывает её, если согласие уже сохранено.
     */
    constructor() {
        this.root = document.querySelector('.cookies-card');
        this.button = this.root ? this.root.querySelector('.cookies-card__button') : null;
        this.cookieName = 'nft_cookie_consent';
        this.cookieValue = 'accepted';
        this.cookieMaxAge = 60 * 60 * 24 * 365;

        if (!this.root || !this.button) {
            return;
        }

        if (this.hasConsent()) {
            this.hide();
            return;
        }

        this.button.addEventListener('click', () => {
            this.accept();
        });
    }

    /**
     * Проверяет, записано ли согласие в cookie браузера.
     */
    hasConsent() {
        const prefix = this.cookieName + '=';

        return document.cookie.split('; ').some((part) => {
            return part.indexOf(prefix) === 0
                && decodeURIComponent(part.slice(prefix.length)) === this.cookieValue;
        });
    }

    /**
     * Записывает согласие в cookie и скрывает карточку.
     */
    accept() {
        const secure = window.location.protocol === 'https:' ? '; Secure' : '';

        document.cookie = [
            this.cookieName + '=' + encodeURIComponent(this.cookieValue),
            'Path=/',
            'Max-Age=' + this.cookieMaxAge,
            'SameSite=Lax',
        ].join('; ') + secure;

        this.hide();
    }

    /**
     * Скрывает карточку уведомления.
     */
    hide() {
        this.root.classList.add('cookies-card--hidden');
    }
}

export default CookiesCard;
